import React, { createContext, useContext, useState } from 'react';

const SelectedTemplateContext = createContext();

export function SelectedTemplateProvider({ children }) {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  return (
    <SelectedTemplateContext.Provider value={{ selectedTemplate, setSelectedTemplate }}>
      {children}
    </SelectedTemplateContext.Provider>
  );
}

export function useSelectedTemplate() {
  return useContext(SelectedTemplateContext);
} 